<div *ngIf="!isLoading else loading">
    <form [formGroup]="siteForm">
        <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true">

            <acabim-form-input-wrapper>
                <acabim-form-input-label>Site name</acabim-form-input-label>
                <acabim-form-input-content [mediumField]="true" note="{{this.currentSite?.id}}">
                    <input type="text" formControlName="siteName">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>

            <acabim-form-input-wrapper>
                <acabim-form-input-label>Location map</acabim-form-input-label>
                <acabim-form-input-content id="map-wrapper">
                    <acabim-map-viewer #mapViewer [path]="mapCoordinates" (selectedMapLocationChanged)="onMapLocationChanged($event)"></acabim-map-viewer>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>

            <acabim-form-input-wrapper>
                <acabim-form-input-label>Attachments</acabim-form-input-label>
                <acabim-form-input-content>
                    <acabim-multifile-upload
                        #fileComp
                        [mimeTypes]="mimetypes"
                        (fileAdded)="onFileAdded($event)"
                        (fileDeleted)="onFileDeleted($event)"
                        (fileLoading)="onFileLoading($event)"
                        [fullFiles]="fullFiles" [hasDelete]="true"></acabim-multifile-upload>
                    <div class="cas-action-buttons align-bottom">
                        <button
                            class="cas-button-action ml-0"
                            type="button"
                            (click)="addToBuilding()"
                            [disabled]="disableAdd">Add</button>
                    </div>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>

            <acabim-form-input-wrapper>
                <acabim-form-input-label>Site Groups</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-multiSelect
                        [options]="groups"
                        optionValue="value"
                        optionLabel="label"
                        formControlName="selectedGroups"></p-multiSelect>
                    <ng-container *ngIf="groupNames.length > 0">
                        —&nbsp;&nbsp;<small>{{groupNames.join(', ')}}</small>
                    </ng-container>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>

            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="onSubmit()" class="cas-button-action cas-button-right">Update</button>
            </div>

        </acabim-form-block>

    </form>
</div>

<ng-template #loading>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
<p-toast position="center"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" key="confirmAttachment"
                 acceptButtonStyleClass="cas-button-action"></p-confirmDialog>
<ng-template #attachment>

    <acabim-multifile-upload #fileComp
                             [mimeTypes]="mimetypes"
                             (fileAdded)="onFileAdded($event)"
                             (fileDeleted)="onFileDeleted($event)"
                             (fileLoading)="onFileLoading($event)"
                             [fullFiles]="fullFiles" [hasDelete]="true"
    ></acabim-multifile-upload>
    <div class="cas-action-buttons">
        <button class="cas-button-action ml-0" type="button" (click)="addToBuilding()" [disabled]="disableAdd">Add
        </button>
    </div>
</ng-template>
